module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-spring.ec6ca32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-spring.png
// module id = XzbU
// module chunks = 0